import React from "react";
import { StyleSheet, View, Text, TouchableHighlight } from "react-native";

const Index = (props) => {
  return (
    <View style={styles.container}>
      <Text style={styles.content}>
        Now, answer the following questions with{" "}
        <Text style={{ fontWeight: "var(--font-weight-bold)" }}>True</Text> or{" "}
        <Text style={{ fontWeight: "var(--font-weight-bold)" }}>False</Text>,
        and let us know how sure you are.{`\n`}
        {`\n`}If you don’t know, take a guess!
      </Text>

      <View style={styles.buttonContainer}>
        <TouchableHighlight
          style={styles.button}
          onPress={() => {
            props.navigation();
          }}
        >
          <Text style={styles.buttonText}>OK, GOT IT!</Text>
        </TouchableHighlight>
      </View>
    </View>
  );
};
export default Index;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },

  content: {
    textAlign: "center",
    fontWeight: "var(--font-weight-thin",
    fontSize: 32,
    letterSpacing: 3.2,
  },

  button: {
    height: "auto",
    width: "auto",
    backgroundColor: "var(--button-background-color-default)",
    borderRadius: 3,
    justifyContent: "center",
    paddingHorizontal: 15,
    paddingVertical: 10,
  },

  buttonText: {
    fontFamily: "var(--font-family-default)",
    fontSize: 16,
    textAlign: "center",
    letterSpacing: 1.5,
    color: "#ffffff",
  },

  buttonContainer: {
    top: 25,
  },
});
